import { v4 as uuidv4 } from "uuid";
import { AddressModel } from "../shared/address";
export class ClientContactModel {
    constructor() {
        this.id = uuidv4();
        this.clientId = "";
        this.firstName = "";
        this.lastName = "";
        this.faceBook = "";
        this.twitter = "";
        this.linkedIn = "";
        this.email = "";
        this.designation = "";
        this.phoneNumber = "";
        this.notes = "";
        this.isReviewer = false;
        this.isKeyContact = false;
        this.visitsByIntlTeam = "";
        this.isActive = false;
        this.contactAddress = new AddressModel();
    }
}
export default class ClientContact extends ClientContactModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
